import * as React from 'react';
import { Carousel, Embla } from '@mantine/carousel';
import { ActionIcon, Group, createStyles, Box, Text } from '@mantine/core';
import { UseFormReturnType } from '@mantine/form';
import { IconUser } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

// Components
import { ContactForm } from '../ContactForm';
import { hydrateManifestSection } from '../Form/helpers/hydrateManifestSection';

// Types
import { IManifestFieldHydrated } from '../../manifests/types';
import { IContactRecord } from '../../types';

const useStyles = createStyles((theme) => ({
    container: {
        marginRight: '-1.25rem !important',
        marginLeft: '-1.25rem !important'
    },
    slide: {
        overflow: 'hidden'
    },
    header: {
        borderTop: '1px solid #dee2e6',
        marginRight: '-1.25rem !important',
        marginLeft: '-1.25rem !important',
        padding: '0.5rem 1.25rem',
        // background: theme.colors.indigo[0],
        // color: theme.colors.indigo[8],
        color: theme.colors.orange[6],
        background: theme.colors.orange[0],
        paddingLeft: '10px'
    }
}));

interface PrimaryContactFormProps<FormValues> {
    data: string;
    subManifest: IManifestFieldHydrated[];
    parentform: UseFormReturnType<FormValues>;
    parentNext?: () => Promise<void>;
    parentPrev?: () => void;
    activeStep?: number;
    surveyId?: string;
    clientId?: string;
    trigger?: string;
}

export function PrimaryContactForm<
    FormValues extends {
        contactsModule?: any[];
    }
>(props: PrimaryContactFormProps<FormValues>) {
    const { t } = useTranslation();
    const { classes, cx } = useStyles();
    const { data, subManifest, parentNext, parentPrev, activeStep, surveyId, clientId, trigger } = props;
    const formProps = React.useMemo(
        () => ({
            isSubForm: true,
            hideCancel: true,
            dirtySaveOnly: false,
            saveLabelKey: 'saveContinue',
            manifestSections: [{ manifest: hydrateManifestSection(subManifest) }],
            formInsert: true,
            drawerCard: true,
            confirmContact: true,
            surveyId,
            clientId,
            trigger
        }),
        [subManifest, surveyId, hydrateManifestSection, trigger]
    );

    return (
        <Box>
            <ContactForm
                contactId={data}
                isNew={typeof data === 'undefined'}
                {...formProps}
                hideNotification={true}
                onSave={() => {
                    parentNext?.();
                }}
                parentPrev={parentPrev}
            />
        </Box>
    );
}
